import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/services";
import { Reveal, Eyebrow, MaskLines } from "../site/Reveal";

const Card = ({ s, i }) => (
  <Reveal delay={(i % 3) * 0.08}>
    <Link
      to={`/services/${s.slug}`}
      data-testid={`service-card-${s.slug}`}
      className="group flex flex-col h-full overflow-hidden rounded-[24px] bg-[#f5f7fa] border border-ink/10 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(15,29,71,0.12)]"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-paper-2">
        <img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-[1.05] transition-[transform,filter] duration-700" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f1d47]/60 via-transparent to-transparent" />
        <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 font-mono-x text-[11px] uppercase tracking-wider text-ink">{String(i + 1).padStart(2, "0")} / {s.kicker}</span>
      </div>
      <div className="flex flex-col flex-1 p-7 sm:p-8">
        <span className="font-display font-extrabold text-5xl tracking-[-0.04em] leading-none text-[var(--brass)]">{s.code}</span>
        <h3 className="mt-4 font-display font-bold text-2xl sm:text-[1.7rem] tracking-tight text-ink">{s.title}</h3>
        <p className="mt-3 text-sm sm:text-base leading-relaxed text-ink/70">{s.short}</p>
        <span className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--brass-deep)]">
          Explore <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
        </span>
      </div>
    </Link>
  </Reveal>
);

export const ServicesBento = () => (
  <section data-testid="services-bento" className="bg-paper py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-14 sm:mb-20">
        <div className="lg:col-span-7">
          <Eyebrow>What we cover</Eyebrow>
          <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-6xl lg:text-7xl">
            <MaskLines inView lines={["Six verticals.", <>One <span className="font-serif-i text-[var(--brass-deep)]">standard</span> of rigour.</>]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-5" delay={0.15}>
          <p className="text-base sm:text-lg text-ink/75 leading-relaxed">
            Comprehensive compliance, regulatory advisory, audit and documentation services — tailored to the specific regulations that govern your registration.
          </p>
        </Reveal>
      </div>
      <div data-testid="services-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {SERVICES.map((s, i) => <Card key={s.slug} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
